import cn from "clsx";
import React, { forwardRef, ForwardRefRenderFunction, RefObject, useContext, useEffect, useImperativeHandle, useState } from "react";
import { useTranslations } from "next-intl";
import { AlertDialog, Flex, Button, Text, Spinner } from "@radix-ui/themes";
import { AlertProps } from "@/components/layout/layoutType";
import { AlertContext } from "@/components/context/alertContext";
import * as dc from "@/components/layout/list/defaultType";

import Icon from "@/components/common/icon/icon";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });
export type AlertHandle = {
  setProp: (prop: AlertProps) => void;
};
const AlertFn: ForwardRefRenderFunction<AlertHandle, AlertProps> = (props1, ref) => {
  const prop = useContext(AlertContext);

  useImperativeHandle(ref, () => ({
    setProp: (set_prop: AlertProps) => {
      if (prop.setProp) {
        prop.setProp(set_prop);
        if (prop.open || set_prop.open !== prop.open) {
          setTimeout(() => {
            setOpen(() => set_prop.open);
          }, 30);
        }
      }
    },
  }));

  const ta = useTranslations("alert");
  const [open, setOpen] = useState<boolean>(prop.open);
  useEffect(() => {
    if (prop.open || open !== prop.open) {
      setTimeout(() => {
        setOpen(() => prop.open);
      }, 30);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prop.open, prop]);
  return (
    <AlertDialog.Root
      open={open}
      onOpenChange={() => {
        prop.open = !prop.open;
        setOpen((prevOpen) => !prevOpen);
      }}
    >
      <AlertDialog.Content maxWidth="450px" className={(prop.loading ?? false) ? "text-center bg-opacity-30" : undefined}>
        {(prop.loading ?? false) ? (
          <Button
            variant="ghost"
            size="4"
            onClick={() => {
              prop.open = !prop.open;
              setOpen((prevOpen) => !prevOpen);
            }}
          >
            <AlertDialog.Title className="hidden">{prop.title}</AlertDialog.Title>
            <AlertDialog.Description className="hidden">{"Loading"}</AlertDialog.Description>
            <Spinner loading>
              <Icon iconType="phosphor" iconName="BoxArrowDown" weight="bold" />
            </Spinner>
            <Text weight="bold">{prop.loadingTitle ?? ta("loading")}</Text>
          </Button>
        ) : (
          <>
            {prop.title !== null ? (
              <AlertDialog.Title>{prop.title}</AlertDialog.Title>
            ) : (
              <AlertDialog.Title className="hidden">{prop.title}</AlertDialog.Title>
            )}
            {prop.description !== null ? (
              <AlertDialog.Description size="2">{prop.description}</AlertDialog.Description>
            ) : (
              <AlertDialog.Description size="2" className="hidden">
                {"Hiddn Description"}
              </AlertDialog.Description>
            )}
            {(prop.useCancel ?? false) || (prop.useOk ?? false) ? (
              <Flex gap="3" mt="4" justify="end">
                {(prop.useCancel ?? false) ? (
                  <AlertDialog.Cancel
                    onClick={(e) => {
                      setTimeout(() => {
                        if (prop.setProp) {
                          prop.setProp({ ...prop, open: false });
                        }
                      }, 150);
                      if (prop.cancelFunction) prop.cancelFunction(e);
                    }}
                  >
                    <Button variant="soft" color="gray" className="cursor-pointer">
                      {prop.cancelTitle ?? ta("cancel")}
                    </Button>
                  </AlertDialog.Cancel>
                ) : (
                  ""
                )}
                {(prop.useOk ?? false) ? (
                  <AlertDialog.Action
                    onClick={(e) => {
                      if (prop.okClose === undefined || prop.okClose) {
                        setTimeout(() => {
                          if (prop.setProp) {
                            prop.setProp({ ...prop, open: false, okClose: undefined });
                          }
                          if (prop.okFunction) {
                            prop.okFunction(e);
                          }
                        }, dc.setTimeoutDelay / 2);
                      } else {
                        if (prop.okFunction) {
                          prop.okFunction(e);
                        }
                      }
                    }}
                  >
                    <Button type="button" variant="solid" className="cursor-pointer">
                      {prop.okTitle ?? ta("ok")}
                    </Button>
                  </AlertDialog.Action>
                ) : (
                  ""
                )}
              </Flex>
            ) : (
              ""
            )}
          </>
        )}
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
};
const Alert = forwardRef(AlertFn);
export default Alert;
